import type { ComponentProps } from "react";
import * as ContextMenu from "zeego/context-menu";
import { useTheme } from "~/providers/ThemeProvider";

export const MenuContent = ContextMenu.create((props: ComponentProps<typeof ContextMenu.Content>) => {
    const { colours } = useTheme();

    return (
        <ContextMenu.Content
            {...props}
            style={{
                backgroundColor: colours.background.secondary,
                borderRadius: 5,
                boxShadow: `1px 3px 3px ${colours.boxShadow}, -1px 0px 3px ${colours.boxShadow}`,
            }}
        />
    );
}, "Content");
